<template>
  <div v-if="show" class="item-country-code-dropdown">

    <wxc-dropdown
        :disabled="!enabledPhoneCodeSelection"
        :config="dropdownConfig"
        :list="getCountryCodes"
        :select-item="getDefaultCountryCode"
        :show-bottom-border="false"
        :hide-additional-details="true"
        @onItemSelected="onPhoneCodeSelected($event.value)"
    ></wxc-dropdown>


  </div>
</template>

<script>
import WxcDropdown from "../../../weex-ui/packages/wxc-dropdown/index";
import { DefaultResourceConfig } from "@/utils/ImageResourcesUtil";
import EzUtils from "@/utils/EzUtils";
import { environment } from "@/environments/environment";

export default {
  name: "PhoneCodeItem",
  components: { WxcDropdown },
  data: () => ({
    selectedCountryCode: ""
  }),

  props: {
    show: {
      type: Boolean,
      required: false,
      default: true
    },

    enabledPhoneCodeSelection: {
      type: Boolean,
      required: false,
      default: true
    },

    defaultCountryCode: {
      type: String,
      required: false
    },

    countryCodes: {
      type: Array,
      required: false,
      default: () => (environment.allowedCountryPhoneCodes)
    }
  },

  methods: {
    onPhoneCodeSelected(countryCode) {
      this.selectedCountryCode = countryCode;
      this.$emit("onPhoneCodeSelected", countryCode);
    }
  },

  computed: {
    getCountryCodes() {
      let countryCodes = [];
      this.countryCodes && this.countryCodes.forEach(countryCode => {
        countryCodes.push({ title: countryCode, value: countryCode });
      });

      return countryCodes;
    },

    getDefaultCountryCode() {
      if (this.selectedCountryCode) {
        return this.selectedCountryCode;
      }

      if (this.defaultCountryCode) {
        return this.defaultCountryCode;
      }

      if (EzUtils.isNotEmpty(this.countryCodes)) {
        return this.countryCodes[0];
      }

      return "";
    },

    dropdownConfig() {
      return DefaultResourceConfig.DROP_DOWN;
    },
  }
}
</script>


<style
    scoped
    src="../../assets/style/base.css"></style>
